<template>
  <el-row class="page" :gutter="24" style="padding-right: 24px;">
    <el-col :span="18">
      <el-card class="box-card">
        <div slot="header" class="clearfix">
          <span>Справочники</span>
          <el-button @click="createNew()" type="primary" icon="el-icon-plus" circle style="float: right;"></el-button>
        </div>

        <el-tabs v-model="activeName">
          <el-select
            v-if="activeName == 'rolls'"
            v-model="rollFilter"
            size="mini"
            placeholder="Фильтр"
            clearable
            style="float: right; margin-bottom: 16px;"
          >
            <el-option :value="1" label="Новые"></el-option>
            <el-option :value="2" label="Активные"></el-option>
            <el-option :value="3" label="С разрывами"></el-option>
            <el-option :value="4" label="Завершенные"></el-option>
          </el-select>
          <el-tab-pane v-for="e of crudKeys" :key="e" :label="dictsNames[e]" :name="e">
            <el-table v-if="dicts[e]" :data="filteredDict(e)" size="mini" :row-class-name="rowStyler">
              <el-table-column width="60" prop="id">
                <template slot-scope="{ row }">
                  <el-button @click="edit(row)" icon="el-icon-edit" size="mini" type="warning" circle plain></el-button>
                </template>
              </el-table-column>
              <el-table-column
                v-for="c of Object.keys(cruds[e]).filter((t) => !cruds[e][t].hidden)"
                :key="c"
                :label="cruds[e][c].title"
                :prop="c"
                :width="cruds[e][c].width"
                :formatter="formatColumn"
              ></el-table-column>
              <el-table-column v-if="activeName == 'rolls'" label="Фискализировано" width="140">
                <template slot-scope="{ row }">
                  <span v-html="ranges[row.id] ? ranges[row.id].range.join(',<br/>') : ''"></span>
                </template>
              </el-table-column>
              <el-table-column v-if="activeName == 'rolls'" label="Статус" width="140">
                <template slot-scope="{ row }">
                  {{ rollStatus(row.id)["title"] }}
                </template>
              </el-table-column>
            </el-table>
          </el-tab-pane>
        </el-tabs>
      </el-card>
    </el-col>

    <el-dialog
      :title="dictsNames[activeName]"
      :visible.sync="isShow"
      width="440px"
      :show-close="false"
      :close-on-click-modal="false"
    >
      <el-form :model="form.data" label-width="160px" v-for="e of fieldKeys" :key="e" size="mini">
        <el-form-item v-if="form.fields[e].readonly !== true" :label="form.fields[e].title" style="text-align: left;">
          <el-input v-if="form.fields[e].type === 'text'" v-model="form.data[e]" type="text"></el-input>
          <el-input-number v-if="form.fields[e].type === 'number'" v-model="form.data[e]"></el-input-number>
          <el-switch
            v-if="form.fields[e].type === 'checkbox'"
            v-model="form.data[e]"
            :active-value="true"
            :inactive-value="false"
          ></el-switch>
          <el-select v-if="form.fields[e].type === 'dict'" v-model="form.data[e]" style="width: 100%">
            <el-option
              v-for="option in dicts[form.fields[e].dict]"
              :key="option.id"
              :label="option.title ? option.title : option.number ? option.number : ''"
              :value="option.id"
              >{{ option.title ? option.title : option.number ? option.number : "" }}</el-option
            >
          </el-select>
        </el-form-item>
      </el-form>

      <span slot="footer" class="dialog-footer">
        <el-button @click="isShow = false">Отмена</el-button>
        <el-button type="primary" @click="save">{{ this.form.data.id ? "Сохранить" : "Добавить" }}</el-button>
      </span>
    </el-dialog>
  </el-row>
</template>

<script>
import moment from "moment-timezone";
import pad from "pad";
import { mapState } from "vuex";

moment.locale("ru");

export default {
  data: () => ({
    activeName: localStorage.activeTab2 ? localStorage.activeTab2 : "transports",
    rollFilter: 2,
    cruds: {
      routes: {
        id: { title: "ID", width: 50, readonly: true },
        number: { title: "Номер", width: 0, type: "text" },
        id_clients: { hidden: true },
        type: { title: "Тип", width: 180, type: "dict", dict: "transportTypes" },
      },
      transports: {
        id: { title: "ID", width: 50, readonly: true },
        number: { title: "Номер", width: 0, type: "text" },
        id_clients: { hidden: true },
      },
      rolls: {
        id: { title: "ID", width: 50, readonly: true },
        id_series: { title: "Серия", width: 0, type: "dict", dict: "series", pad: true },
        id_transports: { title: "ТС", width: 0, type: "dict", dict: "transports" },
        id_routes: { title: "Маршрут", width: 0, type: "dict", dict: "routes" },
        begin_number: { title: "Нач.номер", width: 90, type: "number", pad: true },
        end_number: { title: "Кон.номер", width: 90, type: "number", pad: true },
        last_number: { title: "Последний номер", hidden: true, readonly: true },
        id_clients: { hidden: true },
      },
    },
    isShow: false,
    form: {
      fields: {},
      data: {},
    },
    ranges: {},
  }),
  computed: {
    ...mapState(["dicts", "dictsNames"]),
    crudKeys() {
      return Object.keys(this.cruds);
    },
    fieldKeys() {
      return Object.keys(this.form.fields);
    },
  },
  async created() {
    const crudPromises = [];
    for (const entity of ["series", ...this.crudKeys]) {
      crudPromises.push(
        this.$axios
          .get(`/api/dicts/${entity}`)
          .then((result) => {
            return this.$store.dispatch("updateDict", {
              title: entity,
              dict: result.data.data,
            });
          })
          .catch((e) => console.log(e))
      );
    }
    crudPromises.push(
      this.$axios
        .get(`/api/ranges`)
        .then((result) => (this.ranges = result.data.data.ranges))
        .catch((e) => console.log(e))
    );
    await Promise.all(crudPromises);
  },
  methods: {
    createNew() {
      this.form.data = {};
      this.form.fields = this.cruds[this.activeName];
      Object.keys(this.form.fields).forEach((e) => {
        let val = null;
        if (this.form.fields[e].type == "number") val = 0;
        if (this.form.fields[e].type == "text") val = "";
        if (this.form.fields[e].type == "checkbox") val = false;
        this.$set(this.form.data, e, val);
      });
      console.log(this.form.data);
      this.isShow = true;
    },
    edit(data) {
      console.log(data);
      this.form.data = {};
      this.form.fields = this.cruds[this.activeName];
      Object.keys(this.form.fields).forEach((e) => {
        this.$set(this.form.data, e, data[e]);
      });
      this.isShow = true;
    },
    save() {
      if (this.form.data.id == null) delete this.form.data.id;

      this.$axios
        .post(`/api/dicts/${this.activeName}`, this.form.data)
        .then(() => this.$axios.get(`/api/dicts/${this.activeName}`))
        .then((result) => {
          return this.$store.dispatch("updateDict", {
            title: this.activeName,
            dict: result.data.data,
          });
        })
        .catch((e) => console.log(e));
      this.isShow = false;
    },
    del() {
      this.$axios
        .delete(`/api/dicts/${this.activeName}/${this.form.data.id}`)
        .then(() => this.$axios.get(`/api/dicts/${this.activeName}`))
        .then((result) => {
          return this.$store.dispatch("updateDict", {
            title: this.activeName,
            dict: result.data.data,
          });
        })
        .catch((e) => console.log(e));
      this.isShow = false;
    },
    // eslint-disable-next-line no-unused-vars
    formatColumn(row, column, cellValue, index) {
      const prop = this.cruds[this.activeName][column.property];
      let ret = cellValue;
      if (prop && prop.type == "dict") {
        const rel = this.dicts[prop.dict].find((e) => e.id == cellValue);
        if (rel && rel.title) ret = rel.title;
        if (rel && rel.number) ret = rel.number;
      }
      if (prop && prop.pad) {
        ret = pad(6, parseInt(ret), "0");
      }
      return ret;
    },

    rollStatus(id) {
      if (!this.ranges[id]) return { id: "1", title: "Новая", class: "success-row" };
      if (this.ranges[id].count == 0) return { id: "1", title: "Новая", class: "success-row" };
      if (this.ranges[id].count == this.ranges[id].total) return { id: "4", title: "Завершена", class: "" };
      if (this.ranges[id].range.length > 1) return { id: "3", title: "С разрывами", class: "danger-row" };
      if (this.ranges[id].count > 0) return { id: "2", title: "Активно", class: "primary-row" };
      return { title: "Неизвестно", class: "warning-row" };
    },

    rowStyler({ row }) {
      if (this.activeName == "rolls") {
        const status = this.rollStatus(row.id);
        return status.class;
      }
      return "";
    },

    filteredDict(e) {
      const dict = this.dicts[e];
      if (this.activeName == "rolls" && this.rollFilter) {
        return dict.filter((r) => {
          const status = this.rollStatus(r.id);
          if (this.rollFilter == 2 && status.id == 3) return true;
          return status.id == this.rollFilter;
        });
      }
      return dict;
    },
  },
  mounted() {},
  watch: {
    activeName(newName) {
      localStorage.activeTab2 = newName;
    },
  },
};
</script>

<style scoped>
.box-card {
  margin-bottom: 25px;
}
</style>
<style>
.el-table .warning-row {
  background: #fdf6ec;
}

.el-table .success-row {
  background: #f0f9eb;
}

.el-table .danger-row {
  background: #fde2e2;
}
.el-table .primary-row {
  background: #ecf5ff;
}
</style>
